module.exports = __webpack_public_path__ + "static/zigzag-image4-8a67deb988520963c30141bea0c4092b.png";